import React, { ReactNode } from "react";
import Button from "components/Button";
import { CogIcon, DownloadIcon } from "@heroicons/react/outline";
import { useMediaQuery } from "react-responsive";

interface AnalyticsSectionProps {
  title: string;
  children: ReactNode;
  onCustomizeColumns?: () => void;
  onDownload?: () => void;
  isDownloading?: boolean;
  downloadButtonText?: string;
}

const AnalyticsSection: React.FC<AnalyticsSectionProps> = ({
  title,
  children,
  onCustomizeColumns,
  onDownload,
  isDownloading = false,
  downloadButtonText = "DOWNLOAD REPORT",
}) => {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({ query: "(min-width: 768px) and (max-width: 1024px)" });

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <div className="text-lg font-medium">{title}</div>
        <div className="flex items-center gap-2">
          {onCustomizeColumns && (
            <Button
              icon={{ Icon: CogIcon }}
              text={isMobile || isTablet ? "" : "CUSTOMIZE COLUMNS"}
              className="button button-tertiary"
              onClick={onCustomizeColumns}
            />
          )}
          {onDownload && (
            <Button
              icon={{ Icon: DownloadIcon }}
              text={
                isMobile || isTablet
                  ? ""
                  : isDownloading
                  ? "DOWNLOADING..."
                  : downloadButtonText
              }
              className="button button-tertiary"
              onClick={onDownload}
              disabled={isDownloading}
            />
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default AnalyticsSection;
